// select-another-default-method.component.ts
import { Component, Inject } from '@angular/core';
import { PaymentMethodResponse } from '../../../models/payment-method-response.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RemoveConfirmationDialogComponent } from '../remove-confirmation-dialog/remove-confirmation-dialog.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormUtility } from '../../../../../shared/utils';

@Component({
  selector: 'kt-bridgepay-select-another-default-method',
  templateUrl: './select-another-default-method.component.html',
  styleUrls: ['./select-another-default-method.component.scss'],
})
export class SelectAnotherDefaultMethodComponent {
  notDefaultCards = [];
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SelectAnotherDefaultMethodComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      organization: string;
      customerId: string;
      method: PaymentMethodResponse;
      notDefaultCards: any;
    },
    private formBuilder: FormBuilder,
    private formUtility: FormUtility,
  ) {
    this.notDefaultCards = data.notDefaultCards;

    // Set the first card as default value if available
    const defaultValue = this.notDefaultCards.length > 0 ? this.notDefaultCards[0] : '';

    this.formGroup = this.formBuilder.group({
      cards: [defaultValue, [Validators.required]], // Set default value here
    });
  }

  onCancel(): void {
    this.dialogRef.close({ cancel: true });
  }

  onContinue(): void {
    const dialogRef = this.dialog.open(RemoveConfirmationDialogComponent, {
      width: '500px',
      data: {
        method: this.data.method,
        organization: this.data.organization,
        customerId: this.data.customerId,
        newDefaultCardSelected: this.getFormControl('cards').value,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close();
    });
  }

  getMaskedNumber(method: PaymentMethodResponse): string {
    if (method.type === 'card') {
      return `•••• ${method.token_data.data.card?.last4}`;
    }
  }

  getFormControl(name: string): FormControl {
    return this.formUtility.getFormControl(this.formGroup, name);
  }
}
